import React, { Component } from 'react'
import { Button, Form, Input, Select, Radio, message, Spin, DatePicker, Table, InputNumber, Modal, Tooltip } from 'antd'
import { Link } from 'dva/router'
import NumberFormat from 'react-number-format'
import Currency from 'react-currency-formatter';
import {connect} from 'dva'
import { all, create, get } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import { getTotal } from '../../utils'
import config from '../../utils/config'
const axios = require('axios')
const _ = require('underscore')
var Icon = require('react-fontawesome');

const { Column } = Table;
const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const RangePicker = DatePicker.RangePicker;
const ButtonGroup = Button.Group;
const RadioGroup = Radio.Group;

class IncomeNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            hotels: [],
            employees: [],
            filterByHotel: '',
            days: 0,
            sundays: []
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        if (this.props.incomeType === 'trie')
            this.state = {...this.state, currentHotel: null};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        if (this.props.incomeId) {
            // Inicialización de valores para actualizar

            this.props.dispatch({type: 'app/showLoadingTable'})

            get('Income', this.props.incomeId, {include: 'hotel,employee,employee.parent_category'}).then((resp) => {

                resp.requestedAt = moment(new Date(resp.requestedAt.iso), 'YYYY/MM/DD');
                if (resp.hotel) resp.hotel = {key: resp.hotel.objectId, label: resp.hotel.name};

                // Asignamos los registros del catálogo según si es una categoría principal o una subcategoría
                if (resp.employee && resp.employee.parent_category) {
                    resp.employee.parent_category.children = [resp.employee];

                    this.setState({ 
                        companies: [resp.employee.parent_category], 
                        company_selected: resp.employee.parent_category,
                        employee_selected: resp.employee 
                    })

                    resp.company = {key: resp.employee.parent_category.objectId, label: resp.employee.parent_category.name};
                    resp.employee_list = {key: resp.employee.objectId, label: resp.employee.name};

                } else {
                    resp.employee.children = [];

                    this.setState({ 
                        companies: [resp.employee],
                        company_selected: resp.employee
                    })
                    resp.company = {key: resp.employee.objectId, label: resp.employee.name};
                }
                
                this.props.form.setFieldsValue(resp);
                this.props.dispatch({type: 'app/hideLoadingTable'})
            })
        }

        // Query
        let query = {};
        if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: resp.results[0].objectId, label: resp.results[0].name}});
            this.setState({
                hotels: resp.results
            });
        })


        // Si el usuario administra solo un hotel, entonces se asigna desde el inicio el array de empleados de un dueño
        if (this.state.currentHotel) {
            this.setState({ filterByHotel: this.state.currentHotel.objectId })

            // No mandamos el primer parámetro ya que corresponde al Key que trae un nombre de cliente
            // en éste caso no estamos consultando por nombre sino por hotel
            this.fetchEmployees('', (employees) => {
                this.setState({ employees: employees })
            });
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchHotel (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        this.props.form.setFieldsValue({ company: {key: ''} });      

        if (value && value.key && !value.label) {
            this.fetchHotel(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }

        // Key trae el ID del hotel, entonces se consulta los clientes de dicho hotel
        if (value && value.key && value.label) {
            this.setState({ filterByHotel: value.key })

            setTimeout(() => {
                // No mandamos el primer parámetro ya que corresponde al Key que trae un nombre de cliente
                // en éste caso no estamos consultando por nombre sino por hotel
                this.fetchEmployees('', (employees) => {
                    this.setState({ employees: employees })
                });
            }, 100);
        }
    }


    /**
    * Cuando el select de periodicidad cambia, consulta los empleados
    */
    handleSelectPeriodicityChange (value) {
        if (value) {
            this.fetchEmployees('', (employees) => {
                this.setState({ employees: employees })

                if (this.props.form.getFieldValue('range_date'))
                    this.setDays(this.props.form.getFieldValue('range_date'))
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            //callback('Por favor, elija el hotel al que pertenece el cliente!');

            this.setState({ filterByHotel: null })
            setTimeout(() => {
                this.fetchEmployees('', (employees) => {
                    this.setState({ employees: employees })
                });
            }, 100);

            callback();

        } else {
            callback();
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchEmployees (value, callback) {  
        this.props.dispatch({type: 'app/showLoadingTable'})

        setTimeout(() => {
            if (this.props.form.getFieldValue('periodicity')) {
            
                // Query
                let query = {
                    periodicity: this.props.form.getFieldValue('periodicity'), 
                    payment_type: this.props.form.getFieldValue('payment_type'), 
                    active: true
                };

                if (this.state.currentHotel) {
                    query.type = 'hotel';
                    query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}
                }

                if (this.state.filterByHotel) {
                    query.type = 'hotel';
                    query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.filterByHotel}
                }

                if (!this.state.currentHotel && !this.state.filterByHotel) 
                    query.type = 'trie';

                all('Employee', {where: query}).then((d) => {
                    this.props.dispatch({type: 'app/hideLoadingTable'})

                    const results = d.results;
                    callback(results);

                }).catch(e => {
                    message.error('No hemos podido consultar los registros del hotel seleccionado. Intente de nuevo')    
                });
            } else {
                this.props.dispatch({type: 'app/hideLoadingTable'})
            }

        }, 500);
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    }


    createIncome (data) {
        // Se crea un registro en las cajas por la nómina de cada empleado
        create('Income', data).then(resp => {

            _.extend(data, resp);

        }).catch(e => {
            this.createIncome(data);

        });
    }


    getDateArray (obj) {
        var start = obj.startDate.clone();
        var end = obj.endDate.clone().subtract('1', 'days');
        var res = [];
        
        while(start.isBefore(end)){
            var day = start.format('dddd').toLowerCase();
            
            if( obj[day] ){
                res.push(start.toDate());
            }
            start.add(1, 'd');
        }
        return res;
    }


    /**
    * Establece los días dependiendo al rango de fechas
    */
    setDays (values) {

        if (this.state.employees.length > 0) {
            this.props.dispatch({type: 'app/showLoadingTable'})

            var startAt = moment(values[0]).startOf('day');
            var endAt = moment(values[1]).add('1', 'days').endOf('day');

            var days = endAt.diff(startAt, 'days');
            var sundays = this.getDateArray({
              startDate: startAt,
              endDate: endAt,
              domingo: true,
            });

            this.setState({days: days, sundays: sundays});

            this.state.employees.map((item, key) => {
                let data = {};
                data[item.objectId + '_days'] = days;

                this.props.form.setFieldsValue(data);

                var salary = Number(parseFloat(item.amount_pagadora * days).toFixed(2));

                if (salary > 0 && item.payment_type === 'trie') {

                    // Establece el monto del ISR
                    all('ISR', {
                        where: {
                            inferior_limit: {$lte: salary},
                            superior_limit: {$gte: salary}
                        }
                    }).then(isr_table => {
                        var isr_table = isr_table.results[0];
                        var excessive = Number(parseFloat(salary - isr_table.inferior_limit).toFixed(2));
                        var tax = Number(parseFloat(excessive * (isr_table.percent / 100)).toFixed(2));
                        var isr = Number(parseFloat(tax + isr_table.fee).toFixed(2));

                        all('Subsidy', {
                            where: {
                                inferior_limit: {$lte: salary},
                                superior_limit: {$gte: salary}
                            }
                        }).then(subsidy_table => {
                            var subsidy_table = subsidy_table.results[0];
                            var subsidy = subsidy_table.quantity;

                            data[item.objectId + '_isr'] = '$' + parseFloat(isr - subsidy).toFixed(2);
                            this.props.form.setFieldsValue(data);
                        });

                    });


                    // Establece el monto del IMSS
                    var alta_employe = moment(item.alta_employe).startOf('day');
                    var today = moment(new Date()).add('1', 'days').endOf('day');
                    var years = today.diff(alta_employe, 'years') + 1;

                    all('IntegrationFactor', {
                        where: {
                            year_start: {$lte: years},
                            year_end: {$gte: years}
                        }
                    }).then(factor => {
                        var factor = factor.results[0];
                        var sbc = item.amount_pagadora * factor.integration_factor;

                        all('IMSS').then(imss_table => {

                            // Especie - Cuota Fija
                            var smg = _.find(imss_table.results, {name: 'salary'}).percent_employee;
                            var fee_percent_company = _.find(imss_table.results, {name: 'Especie - Cuota Fija'}).percent_company / 100;
                            var fee_company = Number(parseFloat(smg * days * fee_percent_company).toFixed(2));

                            // Prestaciones en Dinero
                            var cash_benefits_percent_employee = _.find(imss_table.results, {name: 'Prestaciones en Dinero'}).percent_employee / 100;
                            var cash_benefits_percent_company = _.find(imss_table.results, {name: 'Prestaciones en Dinero'}).percent_company / 100;
                            var cash_benefits_employee = Number(parseFloat(sbc * days * cash_benefits_percent_employee).toFixed(2));
                            var cash_benefits_company = Number(parseFloat(sbc * days * cash_benefits_percent_company).toFixed(2));

                            // Pensionados y Beneficiarios
                            var pensions_percent_employee = _.find(imss_table.results, {name: 'Pensionados y Beneficiarios'}).percent_employee / 100;
                            var pensions_percent_company = _.find(imss_table.results, {name: 'Pensionados y Beneficiarios'}).percent_company / 100;
                            var pensions_employee = Number(parseFloat(sbc * days * pensions_percent_employee).toFixed(2));
                            var pensions_company = Number(parseFloat(sbc * days * pensions_percent_company).toFixed(2));

                            // Invalidez y Vida
                            var life_percent_employee = _.find(imss_table.results, {name: 'Invalidez y Vida'}).percent_employee / 100;
                            var life_percent_company = _.find(imss_table.results, {name: 'Invalidez y Vida'}).percent_company / 100;
                            var life_employee = Number(parseFloat(sbc * days * life_percent_employee).toFixed(2));
                            var life_company = Number(parseFloat(sbc * days * life_percent_company).toFixed(2));

                            // Riesgo de Trabajo
                            var risk_percent_company = _.find(imss_table.results, {name: 'Riesgo de Trabajo'}).percent_company / 100;
                            var risk_company = Number(parseFloat(sbc * days * risk_percent_company).toFixed(2));

                            // Guardería y Prestaciones Sociales
                            var social_percent_company = _.find(imss_table.results, {name: 'Guardería y Prestaciones Sociales'}).percent_company / 100;
                            var social_company = Number(parseFloat(sbc * days * social_percent_company).toFixed(2));

                            // Seguro de Retiro
                            var insurance_percent_company = _.find(imss_table.results, {name: 'Seguro de Retiro'}).percent_company / 100;
                            var insurance_company = Number(parseFloat(sbc * days * insurance_percent_company).toFixed(2));

                            // Cesantía y Vejez
                            var layoffs_percent_employee = _.find(imss_table.results, {name: 'Cesantía y Vejez'}).percent_employee / 100;
                            var layoffs_percent_company = _.find(imss_table.results, {name: 'Cesantía y Vejez'}).percent_company / 100;
                            var layoffs_employee = Number(parseFloat(sbc * days * layoffs_percent_employee).toFixed(2));
                            var layoffs_company = Number(parseFloat(sbc * days * layoffs_percent_company).toFixed(2));

                            // Infonavit
                            var infonavit_percent_company = _.find(imss_table.results, {name: 'Infonavit'}).percent_company / 100;
                            var infonavit_company = Number(parseFloat(sbc * days * infonavit_percent_company).toFixed(2));

                            var imss_employee = cash_benefits_employee + pensions_employee + life_employee + layoffs_employee;
                            var imss_company = fee_company + cash_benefits_company + pensions_company + life_company + risk_company + social_company + insurance_company + layoffs_company + infonavit_company;

                            data[item.objectId + '_imss'] = '$' + parseFloat(imss_employee).toFixed(2);
                            this.props.form.setFieldsValue(data);

                            if (key === this.state.employees.length - 1)
                                this.props.dispatch({type: 'app/hideLoadingTable'})
                        });
                    });

                } else {
                    this.props.dispatch({type: 'app/hideLoadingTable'})
                }
            });
        }
    }


    /**
    * Muestra la pantalla para modificar quien es el encargado de pagar la nómina
    */
    setUpdate (item) {
        this.setState({
            changePayment: true,
            currentItem: item
        });
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {};
            data.requestedAt = {__type: 'Date', iso: new Date(values.requestedAt).toISOString()};
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data.startAt = {__type: 'Date', iso: new Date(values.range_date[0]).toISOString()};
            data.endAt = {__type: 'Date', iso: new Date(values.range_date[1]).toISOString()};
            data.periodicity = values.periodicity;
            data.notes = values.notes;
            data.type = 'payroll';
            data.chargedTo = this.props.incomeType;
            data.employees = [];

            if (this.state.currentHotel) {
                data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            _.map(this.state.employees, (item) => {

                // Model
                let employee = {};
                employee.objectId = item.objectId;
                employee.name = item.name;
                employee.salary = item.salary;
                employee.total_infonavit = item.total_infonavit;
                employee.amount_pagadora = item.amount_pagadora;
                employee.amount_missing = item.amount_missing;
                employee.relative = item.relative;
                employee.fee = item.fee;
                employee.bonus_sunday = item.bonus_sunday;
                employee.payment_type = item.payment_type;
                employee.type = item.type;

                values[employee.objectId + '_days'] ? employee.days = values[employee.objectId + '_days'] : employee.days = 0;
                values[employee.objectId + '_break_days'] ? employee.break_days = values[employee.objectId + '_break_days'] : employee.break_days = 0;
                values[employee.objectId + '_isr'] ? employee.total_isr = Number(parseFloat(values[employee.objectId + '_isr'].replace(/[^\d.-]/g, '')).toFixed(2)) : employee.total_isr = 0;
                values[employee.objectId + '_imss'] ? employee.total_imss = Number(parseFloat(values[employee.objectId + '_imss'].replace(/[^\d.-]/g, '')).toFixed(2)) : employee.total_imss = 0;
                values[employee.objectId + '_adjustment'] ? employee.total_adjustment = Number(parseFloat(values[employee.objectId + '_adjustment'].replace(/[^\d.-]/g, '')).toFixed(2)) : employee.total_adjustment = 0;
                values[employee.objectId + '_chargedTo'] ? employee.chargedTo = values[employee.objectId + '_chargedTo'] : null;

                this.state.sundays.length > 0 && employee.bonus_sunday ? employee.total_bonus_sunday = employee.bonus_sunday * this.state.sundays.length : employee.total_bonus_sunday = 0;;

                if (employee.payment_type === 'hotel') {
                    /*employee.total = Number(parseFloat((employee.salary * employee.days) + (employee.amount_pagadora * employee.break_days * 2) + employee.total_adjustment + employee.total_bonus_sunday).toFixed(2));
                    employee.total_pagadora = employee.total;*/
                    employee.total_pagadora = this.getPagadoraAmount(item);
                    employee.total = employee.total_pagadora
                    employee.total_missing = 0;

                } else {
                    /*employee.total_pagadora = Number(parseFloat((employee.amount_pagadora * employee.days) + (employee.amount_pagadora * employee.break_days * 2) - employee.total_isr - employee.total_imss + employee.total_bonus_sunday).toFixed(2));
                    employee.total_missing = Number(parseFloat((employee.amount_missing * employee.days) + employee.total_isr + employee.total_imss - employee.total_bonus_sunday + employee.total_adjustment).toFixed(2));*/
                    employee.total_pagadora = this.getPagadoraAmount(item);
                    employee.total_missing = this.getMissingAmount(item);
                    employee.total = Number(parseFloat(employee.total_pagadora + employee.total_missing).toFixed(2));
                }

                // Dependiendo a la periodicidad se saca el total de los relativos
                if (data.periodicity === 'semanal') {
                    employee.total_relative = employee.relative * 15;

                } else {
                    employee.total_relative = employee.relative * employee.days;
                }

                
                employee.total_honorarios = employee.total_pagadora * (employee.fee / 100);
                employee.total_deductions = Math.abs(0 - employee.total_isr - employee.total_imss);
                employee.total_neto = employee.total - employee.total_infonavit;

                if (employee.days > 0 && employee.total > 0)
                    data.employees.push(employee);
            });

            data.total = getTotal(data.employees, 'total');
            data.total_isr = getTotal(data.employees, 'total_isr');
            data.total_imss = getTotal(data.employees, 'total_imss');
            data.total_adjustment = getTotal(data.employees, 'total_adjustment');
            data.total_deductions = getTotal(data.employees, 'total_deductions');
            data.total_bonus_sunday = getTotal(data.employees, 'total_bonus_sunday');
            data.total_relative = getTotal(data.employees, 'total_relative');
            data.total_honorarios = getTotal(data.employees, 'total_honorarios');
            data.total_pagadora = getTotal(data.employees, 'total_pagadora');
            data.total_missing = getTotal(data.employees, 'total_missing');
            data.total_infonavit = getTotal(data.employees, 'total_infonavit');
            data.total_neto = getTotal(data.employees, 'total_neto');

            // Muestra el modal de resumen de la nómina
            this.setState({payrollResume: true})

            let payroll = {payroll: data, incomes: []};

            // Corremos el array de empleados para crear los gastos correspondiente
            _.map(data.employees, (employee) => {

                // Model Income
                let income = {};
                income.requestedAt = data.requestedAt;
                income.createdBy = data.createdBy;
                income.notified = false;
                income.status = values.status.key;
                income.adjustment = 0;
                income.notEdit = true;
                employee.type === 'hotel' ? income.type = 'cash_funds' : income.type = 'cash_funds_trie';
                //income.payroll = {__type: 'Pointer', className: 'Payroll', objectId: resp.objectId};

                if (data.hotel)
                    income.hotel = data.hotel;

                if (employee.payment_type === 'hotel') {
                    let payroll_hotel = {...income};

                    payroll_hotel.items = 'Nómina de ' + employee.name;
                    payroll_hotel.chargedTo = 'caja';
                    payroll_hotel.amount_income = 0;
                    payroll_hotel.amount_expense = employee.total;

                    console.log('pago hotel', payroll_hotel);
                    
                    if (payroll_hotel.amount_expense > 0)
                        payroll.incomes.push(payroll_hotel);
                }

                if (employee.payment_type === 'pagadora' && employee.total_missing > 0 && employee.chargedTo && employee.chargedTo === 'Hotel') {
                    let pagadora_missing_hotel = {...income};

                    pagadora_missing_hotel.items = 'Nómina de ' + employee.name;
                    pagadora_missing_hotel.chargedTo = 'caja';
                    pagadora_missing_hotel.amount_income = 0;
                    pagadora_missing_hotel.amount_expense = employee.total_missing;

                    console.log('pago pagadora restante por hotel', pagadora_missing_hotel);
                    
                    if (pagadora_missing_hotel.amount_expense > 0)
                        payroll.incomes.push(pagadora_missing_hotel);
                }

                if (employee.payment_type !== 'hotel') {
                    income.amount_income = 0;
                    income.chargedTo = 'trie';

                    var subtotal = employee.total_pagadora + employee.total_relative + employee.total_honorarios;

                    if (employee.payment_type === 'pagadora' && employee.total_pagadora > 0) {
                        let pagadora_base = {...income};
                        pagadora_base.amount_expense = Number(parseFloat(subtotal + (subtotal * 0.16)).toFixed(2));
                        //pagadora_base.items = 'Nómina de ' + employee.name + ' por Workania';
                        pagadora_base.items = 'Nómina de ' + employee.name;

                        console.log('pago pagadora base', pagadora_base);
                        
                        if (pagadora_base.amount_expense > 0)
                            payroll.incomes.push(pagadora_base);
                    }

                    if (employee.payment_type === 'pagadora' && employee.total_missing > 0 && employee.chargedTo && employee.chargedTo === 'Trie') {
                        let pagadora_missing_trie = {...income};
                        pagadora_missing_trie.amount_expense = employee.total_missing;
                        pagadora_missing_trie.items = 'Nómina de ' + employee.name + ' por Efectivo';

                        console.log('pago pagadora restante por trie', pagadora_missing_trie);
                        
                        if (pagadora_missing_trie.amount_expense > 0)
                            payroll.incomes.push(pagadora_missing_trie);
                    }

                    if (employee.payment_type === 'trie' && employee.total_pagadora > 0) {
                        let pago_trie_alta = {...income};
                        pago_trie_alta.amount_expense = Number(parseFloat(subtotal + (subtotal * 0.16)).toFixed(2));
                        pago_trie_alta.items = 'Nómina de ' + employee.name + ' por Alta TRIE';

                        console.log('pago trie base alta', pago_trie_alta);
                        
                        if (pago_trie_alta.amount_expense > 0)
                            payroll.incomes.push(pago_trie_alta);
                    }

                    if (employee.payment_type === 'trie' && employee.total_missing > 0) {
                        let pago_trie_deposito = {...income};
                        pago_trie_deposito.amount_expense = employee.total_missing;
                        pago_trie_deposito.items = 'Nómina de ' + employee.name + ' por Depósito TRIE';

                        console.log('pago trie restante deposito', pago_trie_deposito);
                        
                        if (pago_trie_deposito.amount_expense > 0)
                            payroll.incomes.push(pago_trie_deposito);
                    }
                }
            });

            let payroll_caja = _.filter(payroll.incomes, {chargedTo: 'caja'});
            let payroll_trie = _.filter(payroll.incomes, {chargedTo: 'trie'});

            this.setState({
                payroll: payroll,
                payroll_caja: payroll_caja,
                payroll_trie: payroll_trie,
                amount_payroll_caja: getTotal(payroll_caja, 'amount_expense'),
                amount_payroll_trie: getTotal(payroll_trie, 'amount_expense')
            });
        })
    }


    /**
    * Envío del formulario
    */
    save (e) {
        this.props.dispatch({type: 'app/showLoadingTable'})

        create('Payroll', this.state.payroll.payroll).then(resp => {

            // Corremos el array de empleados para crear los gastos correspondiente
            _.map(this.state.payroll.incomes, (item) => {

                item.payroll = {__type: 'Pointer', className: 'Payroll', objectId: resp.objectId};

                if (item.amount_expense > 0)
                    this.createIncome(item);
            });

            this.props.dispatch({type: 'app/hideLoadingTable'})
            message.success('Se ha creado el registro exitosamente');

            // Oculta el modal del resumen de la nómina
            this.setState({payrollResume: false})

            axios({
                url: config.api + 'jobs/set_hotel_totals',
                method: 'POST',
                headers: {
                    'X-Parse-Application-Id': config.appId,
                    'X-Parse-Master-Key': config.masterKey
                },
            });

        }).catch(e => {
            this.props.dispatch({type: 'app/hideLoadingTable'})

            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error. Intente más tarde')    
        });
    }


    /**
    * Devuelve el monto de la pagadora (Monto base)
    */
    getPagadoraAmount (item) {
        var bonus_sunday;
        var break_days = this.props.form.getFieldValue(item.objectId + '_break_days');

        // Si hay días de descansos trabajados, entonces se lo restamos al bonus del domingo
        if (break_days > 0)
            this.state.sundays.length > 0 && item.bonus_sunday ? bonus_sunday = item.bonus_sunday * (this.state.sundays.length - break_days) : bonus_sunday = 0;
        else
            this.state.sundays.length > 0 && item.bonus_sunday ? bonus_sunday = item.bonus_sunday * this.state.sundays.length : bonus_sunday = 0;

        // Si es nómina de trie se obtiene el isr y el imss
        if (this.props.incomeType === 'trie') {
            var isr = Number(this.props.form.getFieldValue(item.objectId + '_isr').replace(/[^\d.-]/g, ''));
            var imss = Number(this.props.form.getFieldValue(item.objectId + '_imss').replace(/[^\d.-]/g, ''));
        } else {
            var isr = 0;
            var imss = 0;
        }

        // Data
        var pagadora = item.amount_pagadora * this.props.form.getFieldValue(item.objectId + '_days');
        var break_days = Number(parseFloat(item.amount_pagadora * this.props.form.getFieldValue(item.objectId + '_break_days') * 2).toFixed(2));

        // Total pagadora
        var amount = pagadora - isr - imss + break_days + bonus_sunday;

        // Si el que paga es el hotel entonces se le agrega el ajuste al total de la pagadora
        if (item.payment_type === 'hotel')
            amount = amount + Number(this.props.form.getFieldValue(item.objectId + '_adjustment').replace(/[^\d.-]/g, ''));

        return amount;
    }


    /**
    * Devuelve el monto restante
    */
    getMissingAmount (item) {
        var bonus_sunday;
        this.state.sundays.length > 0 && item.bonus_sunday ? bonus_sunday = item.bonus_sunday * this.state.sundays.length : bonus_sunday = 0;

        // Si es nómina de trie se obtiene el isr y el imss
        if (this.props.incomeType === 'trie') {
            var isr = Number(this.props.form.getFieldValue(item.objectId + '_isr').replace(/[^\d.-]/g, ''));
            var imss = Number(this.props.form.getFieldValue(item.objectId + '_imss').replace(/[^\d.-]/g, ''));
        } else {
            var isr = 0;
            var imss = 0;
        }

        var missing = item.amount_missing * this.props.form.getFieldValue(item.objectId + '_days');
        var amount = missing + isr + imss - bonus_sunday;

        if (item.payment_type !== 'hotel')
            amount = amount + Number(this.props.form.getFieldValue(item.objectId + '_adjustment').replace(/[^\d.-]/g, ''));

        if (amount > 0)
            return amount;
        else
            return 0;
    }

    subtractDays (id, value) {
        console.log(this.state.old_value);
        console.log(value);

        let data = {};

        if (this.state.old_value && this.state.old_value > value) {
            data[id + '_days'] = this.props.form.getFieldValue(id + '_days') + 1;
        } else {
            data[id + '_days'] = this.props.form.getFieldValue(id + '_days') - 1;
        }

        console.log(data);
        this.props.form.setFieldsValue(data);

        this.setState({old_value: value})
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div>
                <Form>
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="row">
                            <div className="col-md-2">
                                <FormItem label="Tipo de pago" hasFeedback>
                                    {this.props.form.getFieldDecorator('payment_type', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija el tipo de pago'
                                        }]
                                    })(
                                        <Select size='large' onChange={this.handleSelectPeriodicityChange.bind(this)}>
                                            <Option value="hotel">Pago Directo Hotel</Option>
                                            <Option value="pagadora">Pago Workania</Option>
                                            <Option value="trie">Pago Directo TRIE</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </div>

                            <div className="col-md-2">
                                <FormItem label="Periodicidad del Pago" hasFeedback>
                                    {this.props.form.getFieldDecorator('periodicity', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija la periodicidad'
                                        }]
                                    })(
                                        <Select size='large' onChange={this.handleSelectPeriodicityChange.bind(this)}>
                                            <Option value="semanal">Semanal</Option>
                                            <Option value="catorcenal">Catorcenal</Option>
                                            <Option value="quincenal">Quincenal</Option>
                                            <Option value="mensual">Mensual</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </div>

                            <div className="col-md-3">
                                <FormItem label="Período laboral" hasFeedback>
                                    {this.props.form.getFieldDecorator('range_date', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija el rango de fechas del pago'
                                        }]
                                    })(
                                        <RangePicker 
                                            format="DD-MM-YYYY"
                                            onChange={resp => {
                                                this.setDays(resp);
                                            }} />
                                    )}
                                </FormItem>
                            </div>

                            <div className="col-md-2">
                                <FormItem label="Fecha en que se paga" hasFeedback>
                                    {this.props.form.getFieldDecorator('requestedAt', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, seleccione la fecha',
                                        }]
                                    })(
                                        <DatePicker format="DD-MM-YYYY" />
                                    )}
                                </FormItem>
                            </div>

                            <div className="col-md-2">
                                <FormItem label="Status" hasFeedback>
                                    {this.props.form.getFieldDecorator('status', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija una opción',
                                        }]
                                    })(
                                        <Select 
                                            size='large'
                                            filterOption={false}
                                            labelInValue={true}
                                            optionLabelProp='label'
                                            >
                                            <Option key="pending" label="Pendiente">Pendiente</Option>
                                            <Option key="paidout" label="Pagado">Pagado</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </div>

                            {this.state.employees.length > 0
                                ? <div className="col-md-12">
                                    <Table 
                                        dataSource={this.state.employees} 
                                        rowKey="objectId" 
                                        size="small" 
                                        pagination={false}>

                                        <Column title="Nombre" key="name" render={(item) => (
                                            <span>{item.name}</span>
                                        )}/>

                                        <Column title="S. Diario" key="salary" render={(item) => (
                                            <Currency quantity={item.salary ? item.salary : 0} currency="USD" />
                                        )}/>

                                        <Column title="D. Trab." key="days" width={60} render={(item) => (
                                            <FormItem style={{marginBottom: 0}}>
                                                {this.props.form.getFieldDecorator(item.objectId + '_days', {
                                                    initialValue: 0
                                                })(
                                                    <InputNumber min={0} max={this.state.days - this.props.form.getFieldValue(item.objectId + '_break_days')} className="ant-input ant-input-lg" />
                                                )}
                                            </FormItem>
                                        )}/>

                                        <Column title="Desca. Trabajados" key="break_days" width={60} render={(item) => (
                                            <FormItem style={{marginBottom: 0}}>
                                                {this.props.form.getFieldDecorator(item.objectId + '_break_days', {
                                                    initialValue: 0,
                                                    onChange: this.subtractDays.bind(this, item.objectId)
                                                })(
                                                    <InputNumber min={0} max={this.props.form.getFieldValue(item.objectId + '_break_days') + this.props.form.getFieldValue(item.objectId + '_days')} className="ant-input ant-input-lg" />
                                                )}
                                            </FormItem>
                                        )}/>

                                        {this.props.incomeType === 'trie'
                                            ? <Column title="Subsidio" key="isr" width={80} render={(item) => (
                                                <FormItem style={{marginBottom: 0}}>
                                                    {this.props.form.getFieldDecorator(item.objectId + '_isr', {
                                                        initialValue: '$0'
                                                    })(
                                                        <NumberFormat 
                                                            thousandSeparator={true} 
                                                            prefix={'$'} 
                                                            allowNegative={true}
                                                            disabled={item.type !== 'trie' ? true : false}
                                                            className="ant-input ant-input-lg" />
                                                    )}
                                                </FormItem>
                                            )}/>
                                            : null
                                        }

                                        {this.props.incomeType === 'trie'
                                            ? <Column title="IMSS" key="imss" width={80} render={(item) => (
                                                <FormItem style={{marginBottom: 0}}>
                                                    {this.props.form.getFieldDecorator(item.objectId + '_imss', {
                                                        initialValue: '$0'
                                                    })(
                                                        <NumberFormat 
                                                            thousandSeparator={true} 
                                                            prefix={'$'} 
                                                            allowNegative={true}
                                                            disabled={item.type !== 'trie' ? true : false}
                                                            className="ant-input ant-input-lg" />
                                                    )}
                                                </FormItem>
                                            )}/>
                                            : ''
                                        }

                                        <Column title="Ajuste al Total" key="adjustment" width={80} render={(item) => (
                                            <FormItem style={{marginBottom: 0}}>
                                                {this.props.form.getFieldDecorator(item.objectId + '_adjustment', {
                                                    initialValue: '$0'
                                                })(
                                                    <NumberFormat 
                                                        thousandSeparator={true} 
                                                        prefix={'$'} 
                                                        allowNegative={true}
                                                        className="ant-input ant-input-lg" />
                                                )}
                                            </FormItem>
                                        )}/>

                                        <Column title="P. Dom." key="bonus_sunday" width={80} render={(item) => (
                                            <span>
                                                {this.state.sundays.length > 0
                                                    ? <span>
                                                        {this.props.form.getFieldValue(item.objectId + '_break_days') > 0
                                                            ? <Currency quantity={item.bonus_sunday ? item.bonus_sunday * (this.state.sundays.length - this.props.form.getFieldValue(item.objectId + '_break_days')) : 0} currency="USD" />
                                                            : <Currency quantity={item.bonus_sunday ? item.bonus_sunday * this.state.sundays.length : 0} currency="USD" />
                                                        }
                                                    </span>
                                                    : ''
                                                }
                                            </span>
                                        )}/>

                                        <Column title="Base" key="base" render={(item) => (
                                            <span>
                                                {item.payment_type === 'hotel'
                                                    ? <span>
                                                        <Currency 
                                                            quantity={item.salary && this.props.form.getFieldValue(item.objectId + '_days') ? item.salary * this.props.form.getFieldValue(item.objectId + '_days') : 0} 
                                                            currency="USD" /><br />
                                                        <small>Hotel</small>
                                                    </span>
                                                    : <span>
                                                        <Currency 
                                                            quantity={
                                                                item.salary && this.props.form.getFieldValue(item.objectId + '_days')
                                                                    ? this.getPagadoraAmount(item) - item.total_infonavit
                                                                    : 0
                                                                } 
                                                            currency="USD" /><br />
                                                        <small>{item.payment_type === 'pagadora' ? 'Workania' : 'Alta'}</small>
                                                    </span>
                                                }
                                            </span>
                                        )}/>

                                        <Column title="Restante" key="missing" render={(item) => (
                                            <span>
                                                {item.payment_type !== 'hotel'
                                                    ? <span>
                                                        <Currency 
                                                            quantity={
                                                                item.salary && this.props.form.getFieldValue(item.objectId + '_days') 
                                                                    ? this.getMissingAmount(item)
                                                                    : 0} 
                                                            currency="USD" /><br />
                                                        <small> 
                                                            {item.payment_type === 'pagadora' && this.props.incomeType === 'trie' ? 'TRIE' : ''}
                                                            {item.payment_type === 'pagadora' && this.props.incomeType === 'hotel' && !this.props.form.getFieldValue(item.objectId + '_chargedTo') ? 'Hotel' : ''}
                                                            {item.payment_type === 'trie' ? 'Depósito' : ''}
                                                            {item.payment_type !== 'trie' && this.props.form.getFieldValue(item.objectId + '_chargedTo') ? this.props.form.getFieldValue(item.objectId + '_chargedTo') : ''}
                                                        </small>
                                                    </span>
                                                    : null
                                                }
                                            </span>
                                        )}/>

                                        {this.props.incomeType !== 'trie'
                                            ? <Column title="Cargo Restante a" key="chargedTo" render={(item) => (
                                                <span>
                                                    {item.payment_type === 'pagadora'
                                                        ? <FormItem style={{marginBottom: 0}}>
                                                            {this.props.form.getFieldDecorator(item.objectId + '_chargedTo', {
                                                                initialValue: this.props.incomeType === 'trie' ? 'Trie' : 'Hotel',
                                                            })(
                                                                <Select size='large' disabled={this.props.incomeType === 'trie' ? true : false}>
                                                                    <Option value="Hotel">Hotel</Option>
                                                                    <Option value="Trie">TRIE</Option>
                                                                </Select>
                                                            )}
                                                        </FormItem>
                                                        : null
                                                    }
                                                </span>
                                            )}/>
                                            : ''
                                        }

                                        <Column title="Total" key="total" render={(item) => (
                                            <Currency 
                                                quantity={
                                                    item.salary && this.props.form.getFieldValue(item.objectId + '_days') 
                                                        ? this.getPagadoraAmount(item) + this.getMissingAmount(item)
                                                        : 0
                                                    } 
                                                currency="USD" />
                                        )}/>

                                        <Column title="Infonavit" key="infonavit" width={80} render={(item) => (
                                            <Currency quantity={item.total_infonavit ? item.total_infonavit : 0} currency="USD" />
                                        )}/>

                                        <Column title="Total Neto" key="neto" render={(item) => (
                                            <Currency quantity={
                                                item.salary && this.props.form.getFieldValue(item.objectId + '_days')
                                                    ? this.getPagadoraAmount(item) + this.getMissingAmount(item) - item.total_infonavit
                                                    : 0
                                                } 
                                            currency="USD" />
                                        )}/>
                                    </Table>  
                                </div>
                                : ''
                            }

                            <div className="col-md-12">
                                <FormItem label="Observaciones" hasFeedback>
                                    {this.props.form.getFieldDecorator('notes')(<TextArea rows={3} />)}
                                </FormItem>
                            </div>
                            
                        </div>

                        <div className="row text-center">
                            <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                Continuar
                            </Button>
                        </div>
                    </Spin>
                

                    <Modal
                        visible={this.state.payrollResume}
                        title="Detalles de la nómina"
                        onCancel={() => { this.setState({payrollResume: false}) }}
                        footer={[
                            <Button key="print" type="primary" onClick={() => { this.save() }}>
                                <Icon name="save" /> Generar nómina
                            </Button>
                        ]}
                        style={{top: 10}} 
                    >
                        <Spin spinning={this.props.app.loadingTable}>
                            <div className="row">
                                <div className="col-md-12 marginBottom20">
                                    A continuación se muestra el monto de la nómina correspondiente al Hotel y a TRIE<br />
                                </div>

                                <div className="col-md-12 marginBottom20">
                                    <span className="text-bold" style={{color: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : ''}}>Hotel</span>
                                    <h3><Currency quantity={this.state.amount_payroll_caja ? this.state.amount_payroll_caja : 0} currency="USD" /></h3><br />

                                    <Table 
                                        dataSource={this.state.payroll_caja} 
                                        rowKey="items" 
                                        size="middle" 
                                        pagination={false}>

                                        <Column title="Nombre" key="startAt" render={(item) => (
                                            <span>{item.items}</span>
                                        )} />

                                        <Column title="Monto" key="amount_expense" render={(item) => (
                                            <span>{item.amount_expense ? <Currency quantity={item.amount_expense} currency="USD" /> : ''}</span>
                                        )}/>
                                        
                                        {/*<Column title="Acciones" key="action" width={90}
                                            render={(item) => (
                                                <span className="actions">
                                                    <ButtonGroup>
                                                        <Tooltip placement="right" title="Cambiar quien paga">
                                                            <Button>
                                                                <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                            </Button>
                                                        </Tooltip>
                                                    </ButtonGroup>
                                                </span>
                                            )}
                                        />*/}
                                    </Table>  
                                </div>

                                <div className="col-md-12">
                                    <span className="text-bold" style={{color: '#88bf01'}}>TRIE</span>
                                    <h3><Currency quantity={this.state.amount_payroll_trie ? this.state.amount_payroll_trie : 0} currency="USD" /></h3><br />

                                    <Table 
                                        dataSource={this.state.payroll_trie} 
                                        rowKey="items" 
                                        size="middle" 
                                        pagination={false}>

                                        <Column title="Nombre" key="startAt" render={(item) => (
                                            <span>{item.items}</span>
                                        )} />

                                        <Column title="Monto" key="amount_expense" render={(item) => (
                                            <span>{item.amount_expense ? <Currency quantity={item.amount_expense} currency="USD" /> : ''}</span>
                                        )}/>
                                        
                                        {/*<Column title="Acciones" key="action" width={90}
                                            render={(item) => (
                                                <span className="actions">
                                                    <ButtonGroup>
                                                        <Tooltip placement="right" title="Cambiar quien paga">
                                                            <Button>
                                                                <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                            </Button>
                                                        </Tooltip>
                                                    </ButtonGroup>
                                                </span>
                                            )}
                                        />*/}
                                    </Table> 
                                </div>
                            </div>
                        </Spin>
                    </Modal>

                    <Modal
                        visible={this.state.changePayment}
                        title="Cambiar quien paga"
                        onCancel={() => { this.setState({changePayment: false}) }}
                        footer={[
                            <Button key="print" type="primary" onClick={() => { this.save() }}>
                                <Icon name="save" /> Guardar
                            </Button>
                        ]}
                    >
                        {this.state.changePayment
                            ? <div className="row">
                                <div className="col-md-12 marginBottom20">
                                    <Icon name="user" /><strong>{this.state.currentItem.items}</strong>
                                </div>

                                <div className="col-md-12">
                                    <FormItem>
                                        {this.props.form.getFieldDecorator('type', {
                                            initialValue: 'completo',
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, elija una opción'
                                            }]
                                        })(
                                            <RadioGroup onChange={(e) => { console.log(e.target.value) }}>
                                                <Radio value="completo">Monto completo</Radio>
                                                <Radio value="parcial">Monto parcial</Radio>
                                            </RadioGroup>
                                        )}
                                    </FormItem>
                                </div>

                                {this.props.form.getFieldValue('type') === 'completo'
                                    ? <div className="col-md-6">
                                        <FormItem label="Monto a pagar" hasFeedback style={{margin: 0}}>
                                            {this.props.form.getFieldDecorator('amount_base', {
                                                initialValue: this.state.currentItem.amount_expense || '$0',
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese un monto válido'
                                                }]
                                            })(
                                                <NumberFormat 
                                                    thousandSeparator={true} 
                                                    prefix={'$'} 
                                                    allowNegative={true}
                                                    className="ant-input ant-input-lg" />  
                                            )}
                                        </FormItem>

                                        <small className="color-red">*Este monto se le asignará {this.state.currentItem.chargedTo === 'caja' ? 'a TRIE' : 'al Hotel'}</small>
                                    </div>
                                    : <div>
                                        <div className="col-md-6">
                                            <FormItem label={this.state.currentItem.chargedTo === 'caja' ? 'al Hotel' : 'a TRIE'} hasFeedback>
                                                {this.props.form.getFieldDecorator('amount_base', {
                                                    initialValue: this.state.currentItem.amount_expense || '$0',
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese un monto válido'
                                                    }]
                                                })(
                                                    <NumberFormat 
                                                        thousandSeparator={true} 
                                                        prefix={'$'} 
                                                        allowNegative={true}
                                                        className="ant-input ant-input-lg" />  
                                                )}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-6">
                                            <FormItem label={this.state.currentItem.chargedTo === 'caja' ? 'a TRIE' : 'al Hotel'} hasFeedback>
                                                {this.props.form.getFieldDecorator('amount_missing', {
                                                    initialValue: '$0',
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese un monto válido'
                                                    }]
                                                })(
                                                    <NumberFormat 
                                                        thousandSeparator={true} 
                                                        prefix={'$'} 
                                                        allowNegative={true}
                                                        className="ant-input ant-input-lg" />  
                                                )}
                                            </FormItem>
                                        </div>
                                    </div>
                                }
                            </div>
                            : ''
                        }
                    </Modal>
                </Form>
            </div>
        )
    }
}

IncomeNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({income, app}) => ({income, app}))(Form.create()(IncomeNew))


// WEBPACK FOOTER //
// ./src/components/incomes/payrollNew.js